'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _htmlToReact = require('html-to-react');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _auth = require('redux/modules/auth');

var _semanticUiReact = require('semantic-ui-react');

var _personalDetails = require('redux/modules/personalDetails');

var personalDetails = _interopRequireWildcard(_personalDetails);

var _professionalDetails = require('redux/modules/professionalDetails');

var professionalDetails = _interopRequireWildcard(_professionalDetails);

var _miscellaneousInfo = require('redux/modules/miscellaneousInfo');

var miscellaneousInfo = _interopRequireWildcard(_miscellaneousInfo);

var _infoBlock = require('redux/modules/infoBlock');

var info = _interopRequireWildcard(_infoBlock);

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var _saveUserData = require('redux/modules/saveUserData');

var saveActions = _interopRequireWildcard(_saveUserData);

var _company = require('redux/modules/company');

var _reactStripeElements = require('react-stripe-elements');

require('./Pricing.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pricing = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    template_id: state.templateData.template_id,
    template_data: state.templateData.template_data,
    templateDataComplete: state.templateData,
    user_data: state.saveUserData,
    company_data: state.company,
    user_data_loaded: state.saveUserData.loaded,
    user_data_loading: state.saveUserData.loading,
    user_data_fail: state.saveUserData.user_data_fail,
    resume_name: state.templateData.resume_name,
    user_data_id: state.templateData.user_data_id,
    ReactGA: state.company.ReactGA,
    base_url: state.company.base_url,
    show_resume_edit_label: state.company.show_resume_edit_label,
    basic_builder: state.company.basic_builder,
    basic_builder_design: state.templateData.design_template_id,
    max_resumes: state.company.max_resumes,
    subscribed: state.auth.subscribed
  };
}, {
  pushState: _reactRouterRedux.push,
  cleanTemplateData: _templateData.clean,
  deleteUserData: saveActions.deleteUserData,
  saveUserData: saveActions.save,
  loadUserData: saveActions.load,
  cleanInfo: info.clean,
  updatePersonalDetails: personalDetails.updateBlock,
  addInfo: info.addBlock,
  choose_template: templateActions.chooseTemplate,
  loadDesignTemplateData: templateActions.loadDesignTemplateData,
  chooseUserDataID: templateActions.chooseUserDataID,
  logout_user_client: _auth.logout_user_client,
  updateUserSubscription: _auth.updateUserSubscription,
  showResumeNameModal: templateActions.showResumeNameModal,
  setResumeName: templateActions.setResumeName,
  loadSavedUserData: templateActions.loadSavedUserData,
  showZipRecruiterModal: _company.showZipRecruiterModal,
  showPaymentModal: _company.showPaymentModal
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Pricing, _Component);

  function Pricing(props) {
    (0, _classCallCheck3.default)(this, Pricing);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Pricing.__proto__ || (0, _getPrototypeOf2.default)(Pricing)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Pricing, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!document.getElementById('stripe-script')) {
        var script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/";
        script.id = "stripe-script";
        script.async = true;
        document.head.appendChild(script);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { style: { padding: '100px' } },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { columns: 3 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table,
              { textAlign: 'center', fixed: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Header,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    'Basic'
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    'Unlimited Access'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    '1 Basic Design'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    '1 Basic Content Template'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    '1 Saved Resume'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    'Hiration Branding on Resume'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table,
              { textAlign: 'center', fixed: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Header,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    'Premium: Quarterly'
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    '90-Day Access'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    '20+ Contemporary Resume Designs'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    'Expert Content for 50+ Professions'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    'Unlimited Saved Resumes'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    'No Hiration Branding'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    'Unlimited Downloads in PDF Format'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    {
                      onClick: function onClick(e) {
                        return _this2.props.showPaymentModal(true, 'plan_Cuh9L17jbzVRMa', '₹499');
                      },
                      className: 'payment-quarterly' },
                    'Pay \u20B9499'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table,
              { textAlign: 'center', fixed: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Header,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    'Premium: Monthly'
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    '30-Day Access'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    '20+ Contemporary Resume Designs'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    'Expert Content for 50+ Professions'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    'Unlimited Saved Resumes'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    'No Hiration Branding'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    'Unlimited Downloads in PDF Format'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    {
                      onClick: function onClick(e) {
                        return _this2.props.showPaymentModal(true, 'plan_Cuh8cfYkY5ZCPZ', '₹199');
                      },
                      className: 'payment-monthly' },
                    'Pay \u20B9199'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Pricing;
}(_react.Component)) || _class);
exports.default = Pricing;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Pricing/Pricing.js
// module id = 1764
// module chunks = 0